var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideocamRoundedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.6,
    height: 16.3,
    viewBox: "0 0 33 19.489",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "4ye9aqw8xa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H33V19.489H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4ye9aqw8xa)",
    transform: "translate(0 -.001)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#87878a",
    d: "M31.693.635l-7.215 3.5a.5.5 0 0 0-.061.041v-2.39A1.787 1.787 0 0 0 22.63 0H1.786A1.786 1.786 0 0 0 0 1.786V17.7a1.786 1.786 0 0 0 1.786 1.785H22.63a1.786 1.786 0 0 0 1.786-1.785v-2.389c.021.012.038.029.061.041l7.477 3.629A.72.72 0 0 0 33 18.36V1.409a.9.9 0 0 0-1.307-.774M8.551 3.507H2.934a.866.866 0 0 1 0-1.732h5.617a.866.866 0 1 1 0 1.732m3.51 0h-1.282a.866.866 0 0 1 0-1.732h1.282a.866.866 0 0 1 0 1.732",
    transform: "translate(0 .001)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideocamRoundedIcon);
export default __webpack_public_path__ + "static/media/VideocamRoundedIcon.1411f2aa.svg";
export { ForwardRef as ReactComponent };